import axios from 'axios';

export const getMarketingKpisLatestApi = async ({
  customerId,
  date,
  saveInputs,
  marketingViewId,
}) => {
  const response = await axios.post(
    `admin/customer/${customerId}/get-marketing-kpis-latest`,
    {
      date,
      saveInputs,
      marketingViewId,
    }
  );
  return response.data;
};

export const getMarketingKpisApi = async ({ customerId, date, saveInputs, marketingViewId }) => {
  const response = await axios.post(
    `admin/customer/${customerId}/get-marketing-kpis`, {
      date,
      saveInputs,
      marketingViewId,
    }
    
  );
  return response.data;
};

export const updateMarketingKpisApi = async ({
  customerId,
  date,
  marketingKpis,
}) => {
  const response = await axios.post(
    `admin/customer/${customerId}/update-marketing-kpis`,
    {
      date,
      marketingKpis,
    }
  );
  return response.data;
};

export const getMarketingMonthlySpendDataApi = async ({
  customerId,
  date,
  marketingViewId,
}) => {
  const response = await axios.get(
    `admin/customer/${customerId}/marketing-monthly-spend-data`,
    {
      params: {
        date,
        marketingViewId,
      },
    }
  );
  return response.data;
};

export const getMarketingDailySpendDataApi = async ({
                                                   customerId,
                                                   date,
                                                   marketingViewId,
                                               }) => {
    const response = await axios.get(
        `admin/customer/${customerId}/marketing-daily-spend-data`,
        {
            params: {
                date,
                marketingViewId,
            },
        }
    );
    return response.data;
};

export const getMarketingOverrideApi = async ({ customerId }) => {
  const response = await axios.get(`admin/customer/${customerId}/marketing-override`);
  return response.data;
};

export const saveMarketingOverrideApi = async ({ customerId, rows }) => {
  const response = await axios.post(`admin/customer/${customerId}/marketing-override`, rows);
  return response.data;
};

export const listMarketingViewsApi = async ({ customerId }) => {
  const response = await axios.get(`admin/customer/${customerId}/marketing-views`);
  return response.data || [];
};

export const getMarketingViewBaseSqlApi = async ({ customerId }) => {
  const response = await axios.get(`admin/customer/${customerId}/marketing-views/base-sql`);
  return response.data;
};

export const validateMarketingViewApi = async ({ customerId, sql }) => {
  const response = await axios.post(`admin/customer/${customerId}/marketing-views/validate`, { sql });
  return response.data;
};

export const createMarketingViewApi = async ({ customerId, name, sql }) => {
  const response = await axios.post(`admin/customer/${customerId}/marketing-views`, { name, sql });
  return response.data;
};

export const updateMarketingViewApi = async ({ customerId, viewId, name, sql }) => {
  const response = await axios.put(`admin/customer/${customerId}/marketing-views/${viewId}`, { name, sql });
  return response.data;
};

export const deleteMarketingViewApi = async ({ customerId, viewId }) => {
  const response = await axios.delete(`admin/customer/${customerId}/marketing-views/${viewId}`);
  return response.data;
};